<template>
  <div class="vm-grid sm:vm-grid-cols-1 md:vm-grid-cols-3 vm-gap-x-5 vm-gap-y-1">
    <div class="vm-col-span-2">
      <VTextField
        v-model="data[config.firstName.dataKey]"
        :schema-field="config.firstName.schemaField"
        minlength="2"
        maxlength="35"
      >
        <span v-t="config.firstName.label" class="vm-mr-1" />(<span
          v-t="'labels.required'"
          class="vm-font-normal"
        />)
      </VTextField>
    </div>
    <div>
      <VTextField
        v-model="data[config.middleInitial.dataKey]"
        :schema-field="config.middleInitial.schemaField"
        maxlength="1"
      >
        <span v-t="config.middleInitial.label" />
      </VTextField>
    </div>
    <div class="vm-col-span-2">
      <VTextField
        v-model="data[config.lastName.dataKey]"
        :schema-field="config.lastName.schemaField"
        minlength="2"
        maxlength="35"
      >
        <span v-t="config.lastName.label" class="vm-mr-1" />(<span
          v-t="'labels.required'"
          class="vm-font-normal"
        />)
      </VTextField>
    </div>
    <div>
      <VSelect
        v-model="data[config.suffix.dataKey]"
        :schema-field="config.suffix.schemaField"
      >
        <template #label>
          <span v-t="config.suffix.label"></span>
        </template>
        <gsp-option v-t="config.suffix.label" value=""></gsp-option>
        <gsp-option v-t="'labels.nameSuffixJunior'" value="jr"></gsp-option>
        <gsp-option v-t="'labels.nameSuffixSenior'" value="sr"></gsp-option>
        <gsp-option v-t="'labels.nameSuffix1'" value="i"></gsp-option>
        <gsp-option v-t="'labels.nameSuffix2'" value="ii"></gsp-option>
        <gsp-option v-t="'labels.nameSuffix3'" value="iii"></gsp-option>
        <gsp-option v-t="'labels.nameSuffix4'" value="iv"></gsp-option>
        <gsp-option v-t="'labels.nameSuffix5'" value="v"></gsp-option>
      </VSelect>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import addVModelWatchers from "~/composables/add-v-model-watchers";

const props = defineProps({
  modelValue: Object,
  config: Object,
});

const emit = defineEmits({
  "update:modelValue": null,
});

const data = ref(null);

addVModelWatchers({ props, emit, dataRef: data });
</script>
